import { PACKAGE_TYPES } from '../../../constants';

export const DEFAULT_PACKAGE_TYPE = PACKAGE_TYPES.BASIC;
